import { OrderYandexInfoType } from '@shared/types/order';
import FetchData from '@shared/utils/fetchData/fetchData';

import { CreateOrderYandexPaymentRequest } from '../../';

export const createOrderYandexPayment = async ({ type, ...rest }: CreateOrderYandexPaymentRequest) => {
  return await FetchData.post<OrderYandexInfoType>(`orders/yandex-pay/${type.toLowerCase()}`, {
    body: JSON.stringify({ ...rest })
  });
};
